import { render, staticRenderFns } from "./UserChange.vue?vue&type=template&id=24b967e1&scoped=true&"
import script from "./UserChange.vue?vue&type=script&lang=js&"
export * from "./UserChange.vue?vue&type=script&lang=js&"
import style0 from "./UserChange.vue?vue&type=style&index=0&id=24b967e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b967e1",
  null
  
)

export default component.exports